import React, { createContext, useContext, useState, useEffect } from 'react';

const translations = {
  en: {
    // Navigation
    exploreTours: 'Explore Tours',
    adventureTours: 'Adventure Tours',
    marineTours: 'Marine Tours',
    foodTours: 'Food Tours',
    nightTours: 'Night Tours',
    tourDeals: 'Tour Deals',
    signIn: 'Sign In',
    signUp: 'Sign Up',
    getStarted: 'Get Started',
    logout: 'Logout',
    myBookings: 'My Bookings',
    adminDashboard: 'Admin Dashboard',
    
    // Homepage
    searchTours: 'Search Tours ...',
    popularTours: 'Popular Tours',
    mostBooked: 'Most booked experiences in Puerto Rico',
    viewAll: 'View All',
    quickSearches: 'Quick searches:',
    
    // Tour Cards
    freeCancel: 'Free Cancel',
    spotsLeft: 'spots left',
    only: 'Only',
    popular: 'Popular',
    sellingFast: 'Selling Fast',
    hours: 'hours',
    fullDay: 'Full day',
    
    // Tour Detail
    back: 'Back',
    share: 'Share',
    bookNow: 'Book Now',
    checkAvailability: 'Check Availability',
    highlights: 'Highlights',
    description: 'Description',
    whatsIncluded: "What's Included",
    notIncluded: 'Not Included',
    meetingPoint: 'Meeting Point',
    customerReviews: 'Customer Reviews',
    writeReview: 'Write a Review',
    
    // Booking
    selectDate: 'Select Date',
    selectTime: 'Select Time',
    guests: 'Guests',
    adults: 'Adults',
    children: 'Children',
    total: 'Total',
    proceedToPayment: 'Proceed to Payment',
    
    // Footer
    explore: 'Explore',
    support: 'Support',
    contactUs: 'Contact Us',
    faq: 'FAQ',
    cancellationPolicy: 'Cancellation Policy',
    privacyPolicy: 'Privacy Policy',
    termsOfService: 'Terms of Service',
    discoverMagic: 'Discover the magic of Puerto Rico with our curated tours. From rainforest adventures to bioluminescent bays, we bring you the best of the island.',
    allRightsReserved: 'All rights reserved.',
    
    // CTA Section
    readyToExplore: 'Ready to Explore Puerto Rico?',
    startExploring: 'Start Exploring',
    
    // Trust Badges
    trustedBy: 'Trusted By',
    
    // Auth
    welcomeBack: 'Welcome Back',
    signInToContinue: 'Sign in to continue your adventure',
    email: 'Email',
    password: 'Password',
    dontHaveAccount: "Don't have an account?",
    alreadyHaveAccount: 'Already have an account?',
    createAccount: 'Create Account',
    joinUs: 'Join us and start exploring',
    name: 'Name',
    
    // Common
    loading: 'Loading...',
    error: 'Error',
    success: 'Success',
    save: 'Save',
    cancel: 'Cancel',
    delete: 'Delete',
    edit: 'Edit',
    close: 'Close',
    submit: 'Submit',
    
    // Reviews
    rating: 'Rating',
    yourName: 'Your Name',
    reviewTitle: 'Review Title',
    yourReview: 'Your Review',
    submitReview: 'Submit Review',
  },
  es: {
    // Navigation
    exploreTours: 'Explorar Tours',
    adventureTours: 'Tours de Aventura',
    marineTours: 'Tours Marinos',
    foodTours: 'Tours Gastronómicos',
    nightTours: 'Tours Nocturnos',
    tourDeals: 'Ofertas',
    signIn: 'Iniciar Sesión',
    signUp: 'Registrarse',
    getStarted: 'Comenzar',
    logout: 'Cerrar Sesión',
    myBookings: 'Mis Reservas',
    adminDashboard: 'Panel de Admin',
    
    // Homepage
    searchTours: 'Buscar Tours ...',
    popularTours: 'Tours Populares',
    mostBooked: 'Experiencias más reservadas en Puerto Rico',
    viewAll: 'Ver Todos',
    quickSearches: 'Búsquedas rápidas:',
    
    // Tour Cards
    freeCancel: 'Cancelación Gratis',
    spotsLeft: 'lugares disponibles',
    only: 'Solo',
    popular: 'Popular',
    sellingFast: 'Se Agota Rápido',
    hours: 'horas',
    fullDay: 'Día completo',
    
    // Tour Detail
    back: 'Volver',
    share: 'Compartir',
    bookNow: 'Reservar Ahora',
    checkAvailability: 'Ver Disponibilidad',
    highlights: 'Destacados',
    description: 'Descripción',
    whatsIncluded: 'Qué Incluye',
    notIncluded: 'No Incluido',
    meetingPoint: 'Punto de Encuentro',
    customerReviews: 'Reseñas de Clientes',
    writeReview: 'Escribir Reseña',
    
    // Booking
    selectDate: 'Seleccionar Fecha',
    selectTime: 'Seleccionar Hora',
    guests: 'Huéspedes',
    adults: 'Adultos',
    children: 'Niños',
    total: 'Total',
    proceedToPayment: 'Proceder al Pago',
    
    // Footer
    explore: 'Explorar',
    support: 'Soporte',
    contactUs: 'Contáctanos',
    faq: 'Preguntas Frecuentes',
    cancellationPolicy: 'Política de Cancelación',
    privacyPolicy: 'Política de Privacidad',
    termsOfService: 'Términos de Servicio',
    discoverMagic: 'Descubre la magia de Puerto Rico con nuestros tours seleccionados. Desde aventuras en la selva tropical hasta bahías bioluminiscentes, te traemos lo mejor de la isla.',
    allRightsReserved: 'Todos los derechos reservados.',
    
    // CTA Section
    readyToExplore: '¿Listo para Explorar Puerto Rico?',
    startExploring: 'Comenzar a Explorar',
    
    // Trust Badges
    trustedBy: 'Avalado Por',
    
    // Auth
    welcomeBack: 'Bienvenido de Nuevo',
    signInToContinue: 'Inicia sesión para continuar tu aventura',
    email: 'Correo Electrónico',
    password: 'Contraseña',
    dontHaveAccount: '¿No tienes cuenta?',
    alreadyHaveAccount: '¿Ya tienes cuenta?',
    createAccount: 'Crear Cuenta',
    joinUs: 'Únete y comienza a explorar',
    name: 'Nombre',
    
    // Common
    loading: 'Cargando...',
    error: 'Error',
    success: 'Éxito',
    save: 'Guardar',
    cancel: 'Cancelar',
    delete: 'Eliminar',
    edit: 'Editar',
    close: 'Cerrar',
    submit: 'Enviar',
    
    // Reviews
    rating: 'Calificación',
    yourName: 'Tu Nombre',
    reviewTitle: 'Título de la Reseña',
    yourReview: 'Tu Reseña',
    submitReview: 'Enviar Reseña',
  }
};

const LanguageContext = createContext(null);

export function LanguageProvider({ children }) {
  const [language, setLanguage] = useState(() => {
    const saved = localStorage.getItem('tour_finder_language');
    return saved || 'en';
  });

  useEffect(() => {
    localStorage.setItem('tour_finder_language', language);
  }, [language]);

  const t = (key) => {
    return translations[language]?.[key] || translations.en[key] || key;
  };

  const toggleLanguage = () => {
    setLanguage(prev => prev === 'en' ? 'es' : 'en');
  };

  return (
    <LanguageContext.Provider value={{ language, setLanguage, toggleLanguage, t }}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLanguage() {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
}
